import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "px-4" }
const _hoisted_3 = { class: "pa-4" }
const _hoisted_4 = { class: "actual-card-header" }
const _hoisted_5 = { class: "in-bed" }
const _hoisted_6 = { class: "circle" }
const _hoisted_7 = { class: "number" }
const _hoisted_8 = { class: "circle back" }
const _hoisted_9 = { class: "number" }
const _hoisted_10 = { class: "actual-card-header" }
const _hoisted_11 = { class: "in-bed" }
const _hoisted_12 = { class: "circle" }
const _hoisted_13 = { class: "number" }
const _hoisted_14 = { class: "circle back" }
const _hoisted_15 = { class: "number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_background_component = _resolveComponent("background-component")!
  const _component_position_component = _resolveComponent("position-component")!
  const _component_my_card_body = _resolveComponent("my-card-body")!
  const _component_my_card = _resolveComponent("my-card")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_background_component, {
        left: $setup.left,
        right: $setup.right
      }, null, 8, ["left", "right"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_position_component, {
        modelValue: $setup.position,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.position) = $event))
      }, null, 8, ["modelValue"]),
      ($setup.position === $setup.Position.LEFT)
        ? (_openBlock(), _createBlock(_component_my_card, {
            key: 0,
            class: "actual-card"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[1] || (_cache[1] = _createTextVNode(" 实时监测 ", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["iconfont mr-2", [
                  $setup.left && $setup.left.bedStatus === $setup.BedStatus.ON
                    ? 'iconicon-zaichuang'
                    : 'iconicon-lichuang'
                ]])
                  }, null, 2),
                  _createElementVNode("div", null, _toDisplayString($setup.left && $setup.left.bedStatus === $setup.BedStatus.ON ? "在床" : "离床"), 1)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_my_card_body, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "realtime-title" }, [
                      _createElementVNode("div", { class: "iconfont iconicon-heart mr-2" }),
                      _createTextVNode(" 心率 ")
                    ], -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["gif-content", [$setup.left && $setup.left.heart ? 'heart' : '']])
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString($setup.left && $setup.left.heart ? $setup.left.heart : "--"), 1),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "unit" }, "（BMP）", -1))
                      ])
                    ], 2)
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "realtime-title" }, [
                    _createElementVNode("div", { class: "iconfont iconreport-icon-huxi mr-2" }),
                    _createTextVNode(" 呼吸率 ")
                  ], -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["gif-content", [$setup.left && $setup.left.breath ? 'breath' : '']])
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString($setup.left && $setup.left.breath ? $setup.left.breath : "--"), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "unit" }, "（次/分）", -1))
                    ])
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_my_card, {
            key: 1,
            class: "actual-card"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _cache[6] || (_cache[6] = _createTextVNode(" 实时监测 ", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["iconfont mr-2", [
                  $setup.right && $setup.right.bedStatus === $setup.BedStatus.ON
                    ? 'iconicon-zaichuang'
                    : 'iconicon-lichuang'
                ]])
                  }, null, 2),
                  _createElementVNode("div", null, _toDisplayString($setup.right && $setup.right.bedStatus === $setup.BedStatus.ON ? "在床" : "离床"), 1)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_my_card_body, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "realtime-title" }, [
                      _createElementVNode("div", { class: "iconfont iconicon-heart mr-2" }),
                      _createTextVNode(" 心率 ")
                    ], -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["gif-content", [$setup.right && $setup.right.heart ? 'heart' : '']])
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString($setup.right && $setup.right.heart ? $setup.right.heart : "--"), 1),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "unit" }, "（BMP）", -1))
                      ])
                    ], 2)
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "realtime-title" }, [
                    _createElementVNode("div", { class: "iconfont iconreport-icon-huxi mr-2" }),
                    _createTextVNode(" 呼吸率 ")
                  ], -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["gif-content", [$setup.right && $setup.right.breath ? 'breath' : '']])
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString($setup.right && $setup.right.breath ? $setup.right.breath : "--"), 1),
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "unit" }, "（次/分）", -1))
                    ])
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      ($setup.equipment)
        ? (_openBlock(), _createBlock(_component_my_card, {
            key: 2,
            class: "mt-4"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: `/report/day/${$setup.equipment.id}?temp=1`,
                class: "report-link"
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" 查看睡眠报告 ", -1),
                  _createElementVNode("i", { class: "iconfont icon-right" }, null, -1)
                ]))]),
                _: 1
              }, 8, ["to"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}